import { render, staticRenderFns } from "./storeData4.vue?vue&type=template&id=80147010&scoped=true&"
import script from "./storeData4.vue?vue&type=script&lang=js&"
export * from "./storeData4.vue?vue&type=script&lang=js&"
import style0 from "./storeData4.vue?vue&type=style&index=0&id=80147010&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80147010",
  null
  
)

export default component.exports